import React, { useState } from "react";
import { ReactComponent as ArrowRight } from "../../../assets/images/icon-arrow-right.svg";
import { ReactComponent as ArrowDown } from "../../../assets/images/icon-arrow-down.svg";
import { UserTelemetryConnection } from "../../../api/awsApis";
import useCustomStyles from "../../../hooks/useCustomStyles";
import { activeClientInfoStyles } from "../../../assets/styles/ClientsStyles/activeClientInfoStyles";
import { useSelector } from "react-redux";
import { selectState } from "../../../store/slices/themeSlice";
interface ConnectionCollapseProps {
  connections: UserTelemetryConnection[];
  isFromApp?: boolean;
}

const ConnectionCollapse: React.FC<ConnectionCollapseProps> = ({
  connections,
  isFromApp,
}) => {
  const { theme } = useSelector(selectState);

  const classes = useCustomStyles(activeClientInfoStyles, theme);

  const [connectionsCollapsed, setConnectionsCollapsed] = useState<
    Record<string, boolean>
  >({});
  const [subConnectionsCollapsed, setSubConnectionsCollapsed] = useState<
    Record<string, boolean>
  >({});
  const [blocksCollapsed, setBlocksCollapsed] = useState<
    Record<string, boolean>
  >({});
  // Group connections by apiProvider
  const groupedConnections = connections.reduce((acc, conn) => {
    if (!acc[conn.apiProvider]) acc[conn.apiProvider] = [];
    acc[conn.apiProvider].push(conn);
    return acc;
  }, {} as Record<string, UserTelemetryConnection[]>);

  const handleProviderToggle = (apiProvider: string) => {
    setConnectionsCollapsed((prev) => ({
      ...prev,
      [apiProvider]: !prev[apiProvider],
    }));
  };

  const handleConnectionToggle = (connectionId: string) => {
    setSubConnectionsCollapsed((prev) => ({
      ...prev,
      [connectionId]: !prev[connectionId],
    }));
  };

  const getConnectionStatusClass = (status: string) => {
    const statusLower = status.toLowerCase();
    if (statusLower.includes("inactive") || statusLower.includes("connect") || statusLower.includes("consent")|| statusLower.includes("failed")) {
      return classes.connectionInActiveStatus;
    }
    if (statusLower.includes("active")) {
      return classes.connectionActiveStatus;
    }
    if (statusLower.includes("disabled") || statusLower.includes("disconnected") || statusLower.includes("disabled") || statusLower.includes("deleted")) {
      return classes.connectionDisconnectedStatus;
    }
    return "";
  };

  const getItemStatusClass = (status: string) => {
    const statusLower = status.toLowerCase();
    if (statusLower.includes("inactive") || statusLower.includes("connect") || statusLower.includes("consent") || statusLower.includes("failed")) {
      return classes.connectionInActiveStatus;
    }
    if (statusLower.includes("active")) {
      return classes.connectionActiveStatus;
    }
    if (statusLower.includes("disabled") || statusLower.includes("disconnected") || statusLower.includes("disabled") || statusLower.includes("deleted")) {
      return classes.connectionDisconnectedStatus;
    }
    return "";
  };

  const formatDate = (dateString: string) => {
    try {
      return new Date(dateString).toLocaleString();
    } catch (error) {
      return "Invalid Date";
    }
  };

  const totalConnection = Object.values(groupedConnections).reduce(
    (acc, providerConnections) => acc + providerConnections.length,
    0
  );
  const handleBlockToggle = (itemId: string) => {
    setBlocksCollapsed((prev) => ({
      ...prev,
      [itemId]: !prev[itemId],
    }));
  };
  return (
    <div style={{ flex: "1 1 320px", minWidth: 0 }}>
      <div>
        {/* {totalConnection == 0 && (
          <p className={classes.headerText}>No connections found</p>
        )} */}

        {totalConnection > 0 && (
          <p className={classes.headerText}>
            Connection{totalConnection > 1 ? "s" : ""} on{" "}
            {isFromApp ? "Device" : "Provider Site"}: {totalConnection}
          </p>
        )}
      </div>
      {Object.entries(groupedConnections)
        .sort(([a], [b]) => {
          const aIsManual = a.toUpperCase() === "MANUAL";
          const bIsManual = b.toUpperCase() === "MANUAL";
          if (aIsManual && !bIsManual) return 1;
          if (!aIsManual && bIsManual) return -1;
          return a.localeCompare(b);
        })
        .map(([apiProvider, providerConnections]) => {
          const totalAccounts = providerConnections.reduce(
            (acc, conn) => acc + conn.items.length,
            0
          );

          return (
            <div key={apiProvider} className={classes.mainCollabseContainer}>
              {/* Top-level collapse for apiProvider */}
              <div
                className={classes.firstCollabseContainer}
                onClick={() => handleProviderToggle(apiProvider)}
                role="button"
                tabIndex={0}
                onKeyDown={(e) => {
                  if (e.key === "Enter" || e.key === " ") {
                    handleProviderToggle(apiProvider);
                  }
                }}
                // style={{ backgroundColor: "green" }}
              >
                {connectionsCollapsed[apiProvider] ? (
                  <ArrowDown
                    width={10}
                    height={10}
                    style={{ marginRight: 8 }}
                  />
                ) : (
                  <ArrowRight
                    width={10}
                    height={10}
                    style={{ marginRight: 8 }}
                  />
                )}
                <span className={classes.collabseMainTitle}>{apiProvider}</span>
                <span className={classes.collabseMainSubTitle}>
                  {providerConnections.length}{" "}
                  {providerConnections.length === 1
                    ? "Connection"
                    : "Connections"}
                </span>
                <span className={classes.collabseMainSubTitle}>
                  {totalAccounts} {totalAccounts === 1 ? "Account" : "Accounts"}
                </span>
              </div>

              {connectionsCollapsed[apiProvider] && (
                <div style={{ padding: "0px 16px", paddingLeft: 24 }}>
                  {providerConnections
                    .sort((a, b) => {
                      if (isFromApp) {
                        return a.providerId.localeCompare(b.providerId);
                      } else {
                        // Extract text in parentheses for both items
                        const extractName = (providerId: string) => {
                          return providerId.includes("(")
                            ? providerId.match(/\((.*?)\)/)?.[1] || providerId
                            : providerId;
                        };

                        const nameA = extractName(a.providerId);
                        const nameB = extractName(b.providerId);
                        return nameA.localeCompare(nameB);
                      }
                    })
                    .map((connection) => (
                      <div
                        key={connection.connectionId}
                        style={{ marginBottom: 8 }}
                      >
                        {/* Sub-collapse for each connection */}
                        <div
                          style={{
                            display: "flex",
                            cursor: "pointer",
                            padding: "6px 0",
                            justifyContent: "space-between",
                            flexDirection: "column",
                          }}
                          onClick={() =>
                            handleConnectionToggle(connection.connectionId)
                          }
                          role="button"
                          tabIndex={0}
                          onKeyDown={(e) => {
                            if (e.key === "Enter" || e.key === " ") {
                              handleConnectionToggle(connection.connectionId);
                            }
                          }}
                        >
                          <div>
                            <div
                              style={{ display: "flex", alignItems: "center" }}
                            >
                              {subConnectionsCollapsed[
                                connection.connectionId
                              ] ? (
                                <ArrowDown
                                  width={10}
                                  height={10}
                                  style={{ marginRight: 8 }}
                                />
                              ) : (
                                <ArrowRight
                                  width={10}
                                  height={10}
                                  style={{ marginRight: 8 }}
                                />
                              )}
                              {isFromApp ? (
                                <span className={classes.collabseMainTitle}>
                                  {connection.providerId}
                                </span>
                              ) : (
                                <span className={classes.collabseMainTitle}>
                                  {connection.providerId.includes("(")
                                    ? connection.providerId.match(
                                        /\((.*?)\)/
                                      )?.[1] || connection.providerId
                                    : connection.providerId}
                                </span>
                              )}

                              {connection.isLegacyConnection && (
                                <span style={{
                                  marginLeft: 8,
                                  padding: "2px 8px",
                                  backgroundColor: "#FFF3E0",
                                  color: "#E65100",
                                  borderRadius: "12px",
                                  fontSize: "11px",
                                  fontWeight: 500,
                                  letterSpacing: "0.5px",
                                  textTransform: "uppercase",
                                  flexShrink: 0
                                }}>
                                  Legacy
                                </span>
                              )}

                              <span
                                className={getConnectionStatusClass(
                                  connection.connectionStatus
                                )}
                                style={{ marginLeft: 8, flexShrink: 0 }}
                              >
                                {connection.connectionStatus.toLocaleLowerCase()}
                              </span>

                              <span
                                className={classes.collabseMainSubTitle}
                                style={{
                                  marginLeft: "auto",
                                  textAlign: "right",
                                  minWidth: 100,
                                  flexShrink: 0
                                }}
                              >
                                {connection.items.length}{" "}
                                {connection.items.length === 1
                                  ? "Account"
                                  : "Accounts"}
                              </span>
                            </div>
                          </div>
                        </div>
                        {subConnectionsCollapsed[connection.connectionId] && (
                        <>
                          {/* Redesigned connection info section - more compact with overflow handling */}
                          <div
                            style={{
                              backgroundColor: "#FAFAFA",
                              padding: "8px 12px",
                              marginBottom: connection.isLegacyConnection && connection.reminderValue ? "4px" : "8px",
                              borderRadius: "4px",
                              fontSize: "12px",
                              lineHeight: "1.5",
                              width: "100%",
                              boxSizing: "border-box"
                            }}
                          >
                            <div style={{ 
                              display: "flex", 
                              alignItems: "flex-start", 
                              gap: "4px", 
                              marginBottom: "2px",
                              width: "100%"
                            }}>
                              <span style={{ 
                                color: "#666", 
                                fontSize: "11px", 
                                fontWeight: 500,
                                flexShrink: 0
                              }}>
                                Connection ID:
                              </span>
                              <span style={{ 
                                color: "#333", 
                                fontSize: "12px", 
                                fontFamily: "monospace",
                                wordBreak: "break-all",
                                overflow: "hidden",
                                textOverflow: "ellipsis"
                              }}>
                                {connection.connectionId}
                              </span>
                            </div>
                            {connection.additionalStatus && (
                              <div style={{ 
                                display: "flex", 
                                alignItems: "flex-start", 
                                gap: "4px",
                                width: "100%"
                              }}>
                                <span style={{ 
                                  color: "#666", 
                                  fontSize: "11px", 
                                  fontWeight: 500,
                                  flexShrink: 0
                                }}>
                                  Additional Status:
                                </span>
                                <span style={{ 
                                  color: "#333", 
                                  fontSize: "12px",
                                  wordBreak: "break-word"
                                }}>
                                  {connection.additionalStatus}
                                </span>
                              </div>
                            )}
                          </div>
                          
                          {/* Redesigned legacy info section - compact card with overflow handling */}
                          {connection.isLegacyConnection && connection.reminderValue && (
                            <div
                              style={{
                                backgroundColor: "#FFF8E7",
                                padding: "8px 12px",
                                marginBottom: "8px",
                                borderRadius: "4px",
                                border: "1px solid #FFE5B4",
                                fontSize: "12px",
                                lineHeight: "1.5",
                                width: "100%",
                                boxSizing: "border-box"
                              }}
                            >
                              <div style={{ 
                                display: "flex", 
                                alignItems: "center", 
                                gap: "8px",
                                marginBottom: "4px",
                                color: "#8B5A00",
                                fontSize: "11px",
                                fontWeight: 500,
                                textTransform: "uppercase",
                                letterSpacing: "0.5px"
                              }}>
                                <span>⚑ Legacy Consent Info</span>
                              </div>
                              <div style={{ 
                                display: "flex", 
                                alignItems: "flex-start", 
                                gap: "4px", 
                                marginBottom: "2px",
                                width: "100%"
                              }}>
                                <span style={{ 
                                  color: "#8B5A00", 
                                  fontSize: "11px", 
                                  fontWeight: 500,
                                  flexShrink: 0
                                }}>
                                  Consent Reminder:
                                </span>
                                <span style={{ 
                                  color: "#8B5A00", 
                                  fontSize: "12px",
                                  wordBreak: "break-word"
                                }}>
                                  {connection.reminderValue}
                                </span>
                              </div>
                              {connection.lastConsentTime && (
                                <div style={{ 
                                  display: "flex", 
                                  alignItems: "flex-start", 
                                  gap: "4px",
                                  width: "100%"
                                }}>
                                  <span style={{ 
                                    color: "#8B5A00", 
                                    fontSize: "11px", 
                                    fontWeight: 500,
                                    flexShrink: 0
                                  }}>
                                    Last Consent:
                                  </span>
                                  <span style={{ 
                                    color: "#8B5A00", 
                                    fontSize: "12px",
                                    wordBreak: "break-word"
                                  }}>
                                    {formatDate(`${connection.lastConsentTime}`)}
                                  </span>
                                </div>
                              )}
                            </div>
                          )}
                        </>
                        )}
                        {subConnectionsCollapsed[connection.connectionId] && (
                          <div
                            style={{
                              padding: "8px 0 8px 24px",
                              background: "#F6F6F6",
                            }}
                          >
                            {connection.items.map((item) => (
                              <div
                                key={item.itemId}
                                className={classes.secondaryCollabseContainer}
                              >
                                <div
                                  style={{
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                    margin: "4px 0px",
                                    display: "flex",
                                  }}
                                >
                                  <span
                                    className={classes.accountCardMainTitle}
                                  >
                                    {item.itemName}
                                  </span>
                                  <span
                                    className={getItemStatusClass(
                                      item.itemStatus
                                    )}
                                  >
                                    {item.itemStatus.toLocaleLowerCase()}
                                  </span>
                                </div>
                                <div style={{ margin: "4px 0px" }}>
                                  <span className={classes.accountCardSubTitle}>
                                    Item ID:{" "}
                                  </span>
                                  <span
                                    className={classes.accountCardSubTitleValue}
                                    style={{
                                      wordBreak: "break-all",
                                      fontFamily: "monospace"
                                    }}
                                  >
                                    {item.itemId}
                                  </span>
                                </div>
                                <div style={{ margin: "4px 0px" }}>
                                  <span className={classes.accountCardSubTitle}>
                                    Item Type:
                                  </span>
                                  <span
                                    className={classes.accountCardSubTitleValue}
                                  >
                                    {item.itemType}
                                  </span>
                                </div>

                                <div style={{ margin: "4px 0px" }}>
                                  <span className={classes.accountCardSubTitle}>
                                    Additional Status:
                                  </span>
                                  <span
                                    className={classes.accountCardSubTitleValue}
                                  >
                                    {item.itemStatus}
                                  </span>
                                </div>
                                <div style={{ margin: "4px 0px" }}>
                                  <span className={classes.accountCardSubTitle}>
                                    Last Refresh:{" "}
                                  </span>
                                  <span
                                    className={classes.accountCardSubTitleValue}
                                  >
                                    {formatDate(item.lastRefreshDate)}
                                  </span>
                                </div>
                                {item.lastCalculationDate && (
                                  <div style={{ margin: "4px 0px" }}>
                                    <span
                                      className={classes.accountCardSubTitle}
                                    >
                                      Last Calculation Date:
                                    </span>
                                    <span
                                      className={
                                        classes.accountCardSubTitleValue
                                      }
                                    >
                                      {formatDate(item.lastCalculationDate)}
                                    </span>
                                  </div>
                                )}

                                {item.itemBlocksCount &&
                                  item.itemBlocksCount.length > 0 && (
                                    <div style={{ margin: "8px 0px" }}>
                                      {/* Blocks Count Collapse */}
                                      <div
                                        style={{
                                          display: "flex",
                                          alignItems: "center",
                                          cursor: "pointer",
                                          padding: "4px 0",
                                        }}
                                        onClick={() =>
                                          handleBlockToggle(item.itemId)
                                        }
                                        role="button"
                                        tabIndex={0}
                                        onKeyDown={(e) => {
                                          if (
                                            e.key === "Enter" ||
                                            e.key === " "
                                          ) {
                                            handleBlockToggle(item.itemId);
                                          }
                                        }}
                                      >
                                        <span
                                          className={
                                            classes.accountCardSubTitle
                                          }
                                          style={{ marginRight: 12 }}
                                        >
                                          Blocks{" "}
                                        </span>

                                        {blocksCollapsed[item.itemId] ? (
                                          <ArrowDown
                                            width={10}
                                            height={10}
                                            style={{ marginRight: 8 }}
                                          />
                                        ) : (
                                          <ArrowRight
                                            width={10}
                                            height={10}
                                            style={{ marginRight: 8 }}
                                          />
                                        )}
                                      </div>
                                      {/* Blocks Data */}

                                      {blocksCollapsed[item.itemId] && (
                                        <div
                                          style={{
                                            padding: "8px 12px",
                                            backgroundColor: "#FFF",
                                            borderRadius: "4px",
                                            marginTop: "4px",
                                            border: "1px solid #e0e0e0",
                                          }}
                                        >
                                          {item.itemBlocksCount.map(
                                            (block, index) => (
                                              <div
                                                key={index}
                                                style={{
                                                  padding: "6px 0",
                                                }}
                                              >
                                                <div
                                                  style={{ margin: "2px 0" }}
                                                >
                                                  <span
                                                    className={
                                                      classes.accountCardSubTitle
                                                    }
                                                  >
                                                    Block Type:{" "}
                                                  </span>
                                                  <span
                                                    className={
                                                      classes.accountCardSubTitleValue
                                                    }
                                                  >
                                                    {block.blockType || "N/A"}
                                                  </span>
                                                </div>
                                                <div
                                                  style={{ margin: "2px 0" }}
                                                >
                                                  <span
                                                    className={
                                                      classes.accountCardSubTitle
                                                    }
                                                  >
                                                    Count:{" "}
                                                  </span>
                                                  <span
                                                    className={
                                                      classes.accountCardSubTitleValue
                                                    }
                                                  >
                                                    {block.blocksCount || "N/A"}
                                                  </span>
                                                </div>
                                              </div>
                                            )
                                          )}
                                        </div>
                                      )}
                                    </div>
                                  )}
                              </div>
                            ))}
                          </div>
                        )}
                      </div>
                    ))}
                </div>
              )}
            </div>
          );
        })}
    </div>
  );
};

export default ConnectionCollapse;
